import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import classnames from 'classnames';
import Button from "@scentregroup/ui/components/form/button";
import Paragraph from "@scentregroup/ui/components/paragraph";
import { generatePath } from 'react-router';
import { Link } from 'react-router-dom';
import AnalyticsDataWrapper from '@scentregroup/shared/components/analytics-data-wrapper';
import PotentialLink from '@scentregroup/shared/hub-components/potential-link';
import NonReturnableText from '@scentregroup/shared/components/non-returnable-text';
import { stringToSlug } from '@scentregroup/shared/helpers/slug';
import ConditionalIssueText from '@scentregroup/shared/components/conditional-issue-text';
import { generateStoreFrontUrl } from '@scentregroup/shared/helpers/store';
import { omitAppliedPromotions, classifyAppliedPromotions } from '@scentregroup/shared/helpers/marketplace-promotions';
import makeUniqueProductId from '@scentregroup/shared/helpers/make-unique-product-id';
import { CloudinaryImage, IMAGE_SIZES_THUMBNAIL } from '@scentregroup/shared/hub-components/cloudinary-image';
import { PRODUCT } from '../../../../apps/checkout/src/client/paths';
import { ProductFields } from '../../../../apps/checkout/src/client/types/product-form';
import { IssueSeverity } from '../../../../apps/checkout/src/client/types/marketplace-product';
import { QuantityDebounce } from '../cart-preview-quantity-experiment';
import ProductPrice from './product-price';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const DisplayProductTitle = _ref => {
  let {
    quantity,
    brand,
    title
  } = _ref;
  const productTitle = "".concat(quantity, "x ").concat(brand ? "".concat(brand, " - ") : '').concat(title);
  return /*#__PURE__*/_jsx(Paragraph, {
    type: "small",
    className: style.productName,
    "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_Paragraph",
    children: productTitle
  });
};

const CartProductItem = _ref2 => {
  var _analyticsData$retail, _variantText$replace, _productImage$url, _shop$retailer, _shop$retailer2;

  let {
    shop,
    variantGroupCode,
    sku,
    title,
    productImage,
    currency,
    price,
    discountedPrice,
    applicablePromotions,
    appliedPromotions,
    variantText,
    category,
    brand,
    quantity,
    maxQuantity,
    returnable,
    onChangeQuantity,
    onRemoveClick,
    editUrl,
    analyticsData,
    error,
    isItemLinked = true
  } = _ref2;
  const [appliedCouponPromotions, appliedAutoPromotions] = classifyAppliedPromotions(appliedPromotions);
  const appliedCouponPromotion = appliedCouponPromotions.length ? appliedCouponPromotions[0] : undefined;
  const appliedAutoPromotion = appliedAutoPromotions.length ? appliedAutoPromotions[0] : undefined;

  const analytics = _objectSpread(_objectSpread({
    'data-ecomm-rmatc': 'product',
    'data-ecomm-brand': brand,
    'data-ecomm-category': category,
    'data-product-retailer': shop.name,
    'data-product-retailer-id': (_analyticsData$retail = analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.retailerId) !== null && _analyticsData$retail !== void 0 ? _analyticsData$retail : '',
    'data-product-id': variantGroupCode,
    'data-product-unique-id': makeUniqueProductId(variantGroupCode || sku, shop.id, sku),
    'data-product-name': title,
    'data-product-price': price,
    'data-product-currency': currency,
    'data-product-quantity': quantity,
    'data-product-variant': (_variantText$replace = variantText === null || variantText === void 0 ? void 0 : variantText.replace(/, /g, '|')) !== null && _variantText$replace !== void 0 ? _variantText$replace : '',
    'data-product-variant-sku': sku
  }, appliedCouponPromotion && {
    'data-product-coupon-promotion-id': appliedCouponPromotion.campaignId,
    'data-product-coupon-promotion-name': appliedCouponPromotion.title,
    'data-product-promotion-code': appliedCouponPromotion.couponCode
  }), appliedAutoPromotion && {
    'data-product-auto-promotion-id': appliedAutoPromotion.campaignId,
    'data-product-auto-promotion-name': appliedAutoPromotion.title,
    'data-product-promotion-code': "NoCoupon_".concat(appliedAutoPromotion.campaignId)
  });

  const CartProductItemActions = () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div",
      children: onChangeQuantity && /*#__PURE__*/_jsx(QuantityDebounce, {
        hideLabel: true,
        disabled: maxQuantity === 0 && (error === null || error === void 0 ? void 0 : error.severity) === IssueSeverity.Error,
        value: quantity,
        max: maxQuantity,
        onValueChange: value => onChangeQuantity({
          value,
          name: ProductFields.QUANTITY
        }),
        "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_QuantityDebounce"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: style.cartProductItemActions,
      "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div",
      children: [editUrl && /*#__PURE__*/_jsx("div", {
        className: style.ctaLinkWrapper,
        "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div_4",
        children: /*#__PURE__*/_jsx(Link, {
          className: style.ctaLink,
          "aria-label": "Edit cart item",
          to: editUrl,
          "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div_Link",
          children: "Edit"
        })
      }), onRemoveClick && /*#__PURE__*/_jsx(AnalyticsDataWrapper, _objectSpread(_objectSpread({}, analytics), {}, {
        "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_AnalyticsDataWrapper",
        children: /*#__PURE__*/_jsx(Button, {
          type: "tertiary",
          className: style.button,
          onClick: onRemoveClick,
          "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_AnalyticsDataWrapper_Button",
          children: "Remove"
        })
      }))]
    })]
  });

  const imageData = {
    url: (_productImage$url = productImage === null || productImage === void 0 ? void 0 : productImage.url) !== null && _productImage$url !== void 0 ? _productImage$url : '',
    type: 'SQUARE',
    alt: productImage === null || productImage === void 0 ? void 0 : productImage.description
  };

  const thumbnailImage = /*#__PURE__*/_jsx(CloudinaryImage, {
    className: style.productImage,
    imageSetOrImage: imageData,
    ratio: "2/3",
    resizeMode: "pad",
    minWidth: '96px',
    sizes: IMAGE_SIZES_THUMBNAIL,
    "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_CloudinaryImage"
  });

  const unappliedApplicablePromotions = omitAppliedPromotions({
    applicablePromotions,
    appliedPromotions
  });
  return /*#__PURE__*/_jsxs("div", {
    className: style.cartProductItemWrapper,
    "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div",
    children: [/*#__PURE__*/_jsxs("div", {
      className: style.cartProductItemTopWrapper,
      "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div_div_10",
      children: [isItemLinked ? /*#__PURE__*/_jsx(Link, {
        to: generatePath(PRODUCT, {
          productTitle: brand ? stringToSlug("".concat(brand, "-").concat(title)) : stringToSlug(title),
          productId: variantGroupCode || sku,
          shopId: "".concat(shop.id)
        }),
        "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_Link",
        children: thumbnailImage
      }) : thumbnailImage, /*#__PURE__*/_jsxs("div", {
        className: style.cartProductItemDetails,
        "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div_div",
        children: [isItemLinked ? /*#__PURE__*/_jsx(Link, {
          className: style.productLinkWrapper,
          to: generatePath(PRODUCT, {
            productTitle: brand ? stringToSlug("".concat(brand, "-").concat(title)) : stringToSlug(title),
            productId: variantGroupCode || sku,
            shopId: "".concat(shop.id)
          }),
          "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_Link",
          children: /*#__PURE__*/_jsx(DisplayProductTitle, {
            brand: brand,
            title: title,
            quantity: quantity,
            "data-id": "cart-preview-product-item-experiment_index_Link_DisplayProductTitle"
          })
        }) : /*#__PURE__*/_jsx(DisplayProductTitle, {
          brand: brand,
          title: title,
          quantity: quantity,
          "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_15"
        }), /*#__PURE__*/_jsx(ProductPrice, {
          price: price,
          discountedPrice: discountedPrice,
          "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div_ProductPrice"
        }), unappliedApplicablePromotions === null || unappliedApplicablePromotions === void 0 ? void 0 : unappliedApplicablePromotions.map(promotion => /*#__PURE__*/_jsx(Paragraph, {
          type: "small",
          className: style.applicablePromotion,
          "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_Paragraph",
          children: promotion.title
        }, "".concat(promotion.campaignId, "-").concat(promotion.title))), appliedPromotions === null || appliedPromotions === void 0 ? void 0 : appliedPromotions.map(promotion => /*#__PURE__*/_jsxs(Paragraph, {
          type: "small",
          className: style.appliedPromotion,
          "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_Paragraph_18",
          children: [promotion.title, " applied"]
        }, "".concat(promotion.campaignId, "-").concat(promotion.title))), variantText && /*#__PURE__*/_jsx(Paragraph, {
          type: "small",
          className: style.cartProductItemVariantText,
          "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_Paragraph_19",
          children: variantText
        }), /*#__PURE__*/_jsxs(Paragraph, {
          type: "small",
          className: style.storeName,
          "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div_Paragraph_20",
          children: ["Sold by\xA0", /*#__PURE__*/_jsx(PotentialLink, {
            href: generateStoreFrontUrl((_shop$retailer = shop.retailer) === null || _shop$retailer === void 0 ? void 0 : _shop$retailer.sys.id, (_shop$retailer2 = shop.retailer) === null || _shop$retailer2 === void 0 ? void 0 : _shop$retailer2.slug),
            "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_Paragraph_PotentialLink",
            children: shop.name
          })]
        }), isItemLinked && /*#__PURE__*/_jsx(NonReturnableText, {
          returnable: returnable,
          wrapperClassname: style.nonReturnableTextWrapperDesktop,
          "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_NonReturnableText"
        }), /*#__PURE__*/_jsxs("div", {
          className: style.cartProductItemActionsWrapperDesktop,
          "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div_div",
          children: [/*#__PURE__*/_jsx("div", {
            className: classnames(style.cartProductItemActionsWrapper),
            "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div_div_24",
            children: /*#__PURE__*/_jsx(CartProductItemActions, {
              "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div_CartProductItemActions"
            })
          }), /*#__PURE__*/_jsx(ConditionalIssueText, {
            issue: error,
            "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div_ConditionalIssueText"
          })]
        })]
      })]
    }), isItemLinked && /*#__PURE__*/_jsx(NonReturnableText, {
      returnable: returnable,
      wrapperClassname: style.nonReturnableTextWrapperMobile,
      "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_NonReturnableText"
    }), /*#__PURE__*/_jsxs("div", {
      className: style.cartProductItemActionsWrapperMobile,
      "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div_div",
      children: [/*#__PURE__*/_jsx("div", {
        className: classnames(style.cartProductItemActionsWrapper),
        "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div_div_29",
        children: /*#__PURE__*/_jsx(CartProductItemActions, {
          "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div_CartProductItemActions"
        })
      }), /*#__PURE__*/_jsx(ConditionalIssueText, {
        issue: error,
        "data-id": "cart-preview-product-item-experiment_index_DisplayProductTitle_div_ConditionalIssueText"
      })]
    })]
  });
};

export default CartProductItem;